/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer footercss">
        <div className="align-items-center justify-content-xl-between">
          <Col xl="12" className="font-weight-bold text-center">
            <div style={{color: "#32325d"}}>
             Design & Develop by
            </div>
            <div className="text-center text-danger ">
              <a
                className="font-weight-bold ml-1 text-danger"
                href="http://www.adriitsolutions.com/"
                target="_blank"
              >
                Adri IT Solutions
              </a>
            </div>
          </Col>
        </div>
      </footer>
    );
  }
}

export default Footer;
